import toDollars from './to-dollars';

export function surfsideAddProduct({
  brand,
  category,
  currency,
  name,
  price,
  quantity,
  SKU,
  variation,
}) {
  if (window && typeof window.surf === 'function' && SKU) {
    const formattedSKU = formatSKU(SKU);
    window.surf('addProduct:lume', {
      id: formattedSKU,
      brand,
      category,
      name,
      variant: variation,
      price,
      quantity,
      currency,
    });

    window.surf('setCommerceAction:lume', 'add');
  }
}

export function surfsideRemoveProduct({
  brand,
  category,
  currency,
  name,
  price,
  quantity,
  SKU,
  variation,
}) {
  if (window && typeof window.surf === 'function' && SKU) {
    const formattedSKU = formatSKU(SKU);
    window.surf('addProduct:lume', {
      id: formattedSKU,
      brand,
      category,
      name,
      variant: variation,
      price,
      quantity,
      currency,
    });

    window.surf('setCommerceAction:lume', 'remove');
  }
}

export function surfsideCheckout({ products }) {
  if (
    window &&
    typeof window.surf === 'function' &&
    products &&
    Array.isArray(products) &&
    products.length > 0
  ) {
    for (const product of products) {
      const {
        brand,
        category,
        discountedPricePerQuantity: {
          discountedPrice: { centAmount: discountedCents } = {},
        } = {},
        price: { centAmount: fullPriceCents, currencyCode } = {},
        name,
        quantity,
        SKU,
        variation,
      } = product;

      const displayCents = discountedCents || fullPriceCents;
      const formattedPrice = toDollars(displayCents).toFixed(2);

      window.surf('addProduct:lume', {
        id: SKU,
        brand,
        category,
        currency: currencyCode,
        name,
        price: formattedPrice,
        quantity,
        variant: variation,
      });
    }

    window.surf('setCommerceAction:lume', 'checkout');
  }
}

function formatSKU(SKU) {
  if (!SKU) {
    return;
  }
  const splitSKU = SKU.split('_');
  splitSKU.pop();
  return splitSKU.join('_');
}
